// Triggers Search and Add Tab(2699758070)
/*
Ashraf 09/22/2022  2699758070  event tactics sidebar changes
Sohel  10/15/2022  2699758070  Added Code Comments
Ashraf  10/28/2022  2699758070 moved main tabs to header
Raghu 10/28/2022 2699758070 Card Styling Fixes
saikrishna 11/25/2022 2699758070 Added SaveAlert
Ashraf 12/20/2022 2699758070 fixed user role access
Prakash 12/26/2022 2699758070 Removed unused styles.
 */
import React, {useState, useContext, useEffect} from 'react';
import SearchEventTactics from './SearchEventTactics';
import AddEventTactic from './AddEventTactic';
import {useSelector} from 'react-redux';
import SaveAlert from '../../../components/DialogBox/SaveAlert';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import TriggerMaintenanceUsage from './TriggerMaintenanceUsage';

export default function EventTacticSubTabs() {
  const [value, setValue] = useState(0);
  const [eventTacticCode, setEventTacticCode] = useState(null);
  const [rowSelected, setRowSelected] = useState(false);
  const [roleDataEvent, setRoleDataEvent] = useState({});
  const {roleData} = useSelector(({role}) => role);
  const [isCopyIcon, setIsCopyIcon] = useState(false);
  const [triggerMaintenanceData, setTriggerMaintenanceData] = useState([]);
  const [open, setOpen] = useState(false);
  const {setGlobalFieldRow, sample, setNewTabValue} =
    useContext(SelectTabContextProvider);

  const handleTabChange = (event, newValue) => {
    if (value === 1 && sample && newValue === 0) {
      setOpen(true);
      setNewTabValue(newValue);
    } else {
      setValue(newValue);
    }
    setGlobalFieldRow(false);
  };

  // set Role Access(2699758070)
  useEffect(() => {
    setRoleDataEvent(roleData ? roleData?.window?.['Event Tactic']?.ET : {});
  }, [roleData]);
  return (
    <div>
      {open && <SaveAlert setTabValue={setValue} setOpen={setOpen} open={open} tabvalue={value} />}
      {value === 0 && (
        <SearchEventTactics
          setEventTacticCode={setEventTacticCode}
          setValue={setValue}
          value={value}
          setRowSelected={setRowSelected}
          roleDataEvent={roleDataEvent}
          setIsCopyIcon={setIsCopyIcon}
          isCopyIcon={isCopyIcon}
          setTriggerMaintenanceData={setTriggerMaintenanceData}
        />
      )}
      {value === 1 && (
        <AddEventTactic
          handleTabChange={handleTabChange}
          eventTacticCode={eventTacticCode}
          setEventTacticCode={setEventTacticCode}
          setValue={setValue}
          value={value}
          rowSelected={rowSelected}
          roleDataEvent={roleDataEvent}
          isCopyIcon={isCopyIcon}
        />
      )}
      {value === 2 && <TriggerMaintenanceUsage triggerMaintenanceData={triggerMaintenanceData} setValue={setValue}/>}
    </div>
  );
}
